import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';


export default function initCarouselPosts(): void {
    const $carouselPostsContainer = document.querySelectorAll<HTMLElement>('.block-carousel-posts');
    $carouselPostsContainer.forEach($container => {
        new CarouselPosts($container);
    });
}

class CarouselPosts {
    $el: HTMLElement | null | undefined;
    $slider: HTMLElement | null | undefined;
    $navigation_prev: HTMLElement | null | undefined;
    $navigation_next: HTMLElement | null | undefined;
    $pagination: HTMLElement | null | undefined;
    swiper: Swiper | null = null;


    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.$slider = $el?.querySelector('.carousel-posts');
        this.$navigation_prev = $el?.querySelector('.carousel-posts-navigation .button-prev');
        this.$navigation_next = $el?.querySelector('.carousel-posts-navigation .button-next');
        this.$pagination = $el?.querySelector('.carousel-posts-pagination');
        this.init();
    }

    init(): void {
        if (this.$slider) {
            this.swiper = new Swiper(this.$slider, {
                modules: [Navigation, Pagination],
                slidesPerView: 'auto',
                loop: false,
                allowTouchMove: true,
                spaceBetween: 20,
                grabCursor: true,
                pagination: {
                    el: this.$pagination,
                    clickable: true,
                },
                navigation: {
                    nextEl: this.$navigation_next,
                    prevEl: this.$navigation_prev,
                },
                breakpoints: {
                    768: {
                        spaceBetween: 30,
                    },
                },
            });
        }
    }
}
